import { fetchAppAPI } from "../../utils/api";
import { APIDateStringFormatter } from "../../utils/formatters";

const getInitialHistoricPricePoints = async (isin, lastSessionDate, initialTargetOffset) => {
    return new Promise(async (resolve, reject) => {
        try {
            const last = new Date(lastSessionDate)
            const initialTargetLimitDate = APIDateStringFormatter(new Date(last.setDate(last.getDate() - initialTargetOffset)))
            const params = "/historic/initial/" + isin
            const query = `initialTargetLimitDate=${initialTargetLimitDate}`
            const data = await fetchAppAPI(params, query)
            resolve(data.map((point) => {
                return {
                    price: point.price ?? 0,
                    yield: point.yield ?? 0,
                    sessionDate: new Date(point.sessionDate)
                }
            }))
        } catch (e) {
            reject(e)
        }
    })
}

const getRangedHistoricPricePoints = async (isin, targetLimitDate, currentLimitDate) => {
    return new Promise(async (resolve, reject) => {
        try {
            const current = new Date(currentLimitDate)
            const params = "/historic/ranged/" + isin
            const query = `targetLimitDate=${APIDateStringFormatter(targetLimitDate)}&currentLimitDate=${APIDateStringFormatter(new Date(current.setDate(current.getDate() + 1)))}`
            const data = await fetchAppAPI(params, query)
            resolve(data.map((point) => {
                return {
                    price: point.price ?? 0,
                    yield: point.yield ?? 0,
                    sessionDate: new Date(point.sessionDate)
                }
            }))
        } catch (e) {
            reject(e)
        }
    })
}

const getComplementaryHistory = async (isin) => {
    return new Promise(async (resolve, reject) => {
        try {
            const params = "/historic/complementary/" + isin
            const data = await fetchAppAPI(params)
            resolve({
                ...data,
                lastYearsPriceYieldLimits: data.lastYearsPriceYieldLimits.length ? {
                    lower: {
                        sessionDate: new Date(data.lastYearsPriceYieldLimits[1].sessionDate),
                        price: data.lastYearsPriceYieldLimits[1].price ?? 0,
                        yield: data.lastYearsPriceYieldLimits[1].yield ?? 0,
                    },
                    higher: {
                        sessionDate: new Date(data.lastYearsPriceYieldLimits[0].sessionDate),
                        price: data.lastYearsPriceYieldLimits[0].price ?? 0,
                        yield: data.lastYearsPriceYieldLimits[0].yield ?? 0,
                    }
                } : null,
                absolutePriceYieldLimits: data.absolutePriceYieldLimits.length ? {
                    lower: {
                        sessionDate: new Date(data.absolutePriceYieldLimits[1].sessionDate),
                        price: data.absolutePriceYieldLimits[1].price ?? 0,
                        yield: data.absolutePriceYieldLimits[1].yield ?? 0,
                    },
                    higher: {
                        sessionDate: new Date(data.absolutePriceYieldLimits[0].sessionDate),
                        price: data.absolutePriceYieldLimits[0].price ?? 0,
                        yield: data.absolutePriceYieldLimits[0].yield ?? 0,
                    }
                } : null,
            })
        } catch (e) {
            reject(e)
        }
    })
}

export {
    getInitialHistoricPricePoints,
    getComplementaryHistory,
    getRangedHistoricPricePoints
}